export default __webpack_public_path__ + "css/invoice.bundle.css";